import { useTranslation } from 'react-i18next'

export default function Certificates({ certificationNames }) {
	const { t } = useTranslation()

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.certifications')}</h2>
			<div className="mt-4 flex flex-wrap gap-2">
				{certificationNames.length ? certificationNames.map(name => (
					<span
						key={name}
						className="inline-flex items-center rounded-full border border-indigo-100 bg-indigo-50 px-2.5 py-1 text-xs font-medium text-indigo-700"
					>
						{name}
					</span>
				)) : (
					<span className="text-sm text-gray-500">{t('trainings.details.emptyCertifications')}</span>
				)}
			</div>
		</div>
	)
}
